import React from "react";
import { Props } from "./types";
import styles from "./styles.scss";

function StrategicAxisCode({ code, color }: Props) {
  return (
    <div
      className={styles.tag}
      style={{
        backgroundColor: color,
      }}
    >
      {code}
    </div>
  );
}

export { StrategicAxisCode };
